<!-- TEMPLATE -->
<template>
  <select
    class="custom-select"
    name="domain_selector"
    id="dropdown_domain_list"
    v-model="selected"
    @change="selectOption(selected)"
  >
    <option disabled value="" style="color: black">
      Please select a domain
    </option>
    <option v-for="item in domains" v-bind:value="item" v-bind:key="item">
      {{ item }}
    </option>
  </select>
</template>

<!-- SCRIPT -->
<script>
//import UserInfoStore from '../app/user-info-store';
import PhishingApi from "../app/phishing-api";

export default {
  name: "DropdownDomains",
  data: function () {
    return {
      userInfo: this.$store.state.cognitoInfo,
      domains: null,
      default_domain_index: 0,
      selected: this.$store.state.activeDomain,
      domain_is_set: true,
      domain: "",
    };
  },
  created() {
    let self = this;
    PhishingApi.getDomainList().then(function (value) {
      self.domains = value[0].domain;
      self.default_domain_index = value[0].default_domain_index;
      self.selected = value[0].domain[self.default_domain_index];
      self.$store.commit("setActiveDomain", self.selected);
      self.$store.dispatch("refreshPhishingWebsites");
      self.$store.dispatch("refreshGraphs");
      if (self.domains.length == 0) {
        self.domain_is_set = false;
      } else {
        self.domain_is_set = true;
      }
    });
  },
  methods: {
    selectOption(value) {
      console.log(value);
      this.$store.commit("setActiveDomain", value);
      this.$store.dispatch("refreshPhishingWebsites");
      this.$store.dispatch("refreshGraphs");
    },
  },
};
</script>

<!-- Style -->
<style>
@media only screen and (max-width: 600px) {
  #dropdown_domain_list {
    color: black;
  }
}
</style>